import loggingService from '@/services/util/loggingService'
import dateService from '@/services/util/dateService'

var serviceName = 'caseReportService'
var path = '/CaseReport/'
var isDebug = false

function caseFullReportGen (http, caseId) {
    loggingService.log(isDebug, serviceName, 'caseFullReportGen')
    return http.post(path + `CaseFullReportGen?caseId=` + caseId, {caseId: caseId}, { responseType: 'arraybuffer' })
}

function caseInitialReportGen (http, caseId) {
    loggingService.log(isDebug, serviceName, 'caseInitialReportGen')
    return http.post(path + `CaseInitialReportGen?caseId=` + caseId, {caseId: caseId}, { responseType: 'arraybuffer' })
}

function deathTypeReportGen (http, caseId, deathType) {
    loggingService.log(isDebug, serviceName, 'deathTypeReportGen, caseId: ' + caseId + ', deathType: ' + deathType)
    return http.post(path + `DeathTypeReportGen?caseId=` + caseId + `&deathType=` + deathType, {caseId: caseId, deathType: deathType}, { responseType: 'arraybuffer' })
}

function caseNarrativeReportGen (http, caseId) {
    return http.post(path + `CaseNarrativeReportGen?caseId=` + caseId, { caseId: caseId }, { responseType: 'arraybuffer' })
}

function generateDateRangeTotalsReport (http, startDate, endDate) {
    loggingService.log(isDebug, serviceName, 'dateRangeTotalsReport')
    startDate = dateService.toDateTimeString(startDate)
    endDate = dateService.toDateTimeString(endDate)
    console.log(startDate)
    return http.post(path + 'CaseDateRangeReportGen?startDate=' + startDate + '&endDate=' + endDate)
}

function generateYearToDateReport (http, year) {
    loggingService.log(isDebug, serviceName, 'yearToDateReportGen')
    return http.post(path + 'CaseYearToDateReportGen?year=' + year)
}

function generateNonJurisdictionalReport (http, year) {
    loggingService.log(isDebug, serviceName, 'generateNonJurisdictionalReportGen')
    return http.post(path + 'NonJurisdictionalReportGen?year=' + year)
}

function generateAnnualReportPdf (http, list, filename, year, type) {
    loggingService.log(isDebug, serviceName, 'annualReportPdfGen')
    return http.post(path + 'AnnualCaseReportGen?fileName=' + filename + '&year=' + year + '&type=' + type, list, {responseType: 'arraybuffer'})
}

function generateDateRangePdf (http, list, filename, startDate, endDate, reportType) {
    loggingService.log(isDebug, serviceName, 'dateRangeReportPdfGen')
    startDate = dateService.convertToLocalDateString(startDate)
    endDate = dateService.convertToLocalDateString(endDate)
    return http.post(path + 'DateRangeReportPdfGen?fileName=' + filename + '&startDate=' + startDate + '&endDate=' + endDate + '&reportType=' + reportType, list, {responseType: 'arraybuffer'})
}

export default {
    caseFullReportGen: caseFullReportGen,
    caseInitialReportGen: caseInitialReportGen,
    deathTypeReportGen: deathTypeReportGen,
    caseNarrativeReportGen: caseNarrativeReportGen,
    generateDateRangeTotalsReport: generateDateRangeTotalsReport,
    generateYearToDateReport: generateYearToDateReport,
    generateNonJurisdictionalReport: generateNonJurisdictionalReport,
    generateAnnualReportPdf: generateAnnualReportPdf,
    generateDateRangePdf: generateDateRangePdf
}
